export const reportFields = {
  gridJourneyWork: [
    "startDate",
    "startLocation",
    "endDate",
    "endLocation",
    "distance",
    "travelTime",
    "restTime",
    "speed",
    "maxSpeed",
    "driver",
  ],
  gridTravelledDistance: [
    "distance",
    "startDate",
    "startAddress",
    "endDate",
    "endAddress",
  ],
  gridVehicleActivities: [
    "dayOfWeek",
    "generationDate",
    "km",
    "ignitionOn",
    "engineTime",
    "ignitionOff",
    "filteredSpeedCount",
    "unfilteredSpeedCount",
  ],
  gridVehiclePositions: [
    "generationDate",
    "statusDescription",
    "ignition",
    "event",
    "speed",
    "location",
    "mainBattery",
    "backupBattery",
  ],
  gridPeriodVisits: [
    "licensePlate",
    "startDate",
    "duration",
    "eventType",
    "location",
  ],
  gridVisitAmount: [
    "location",
    "startDate",
    "duration",
    "eventType",
    "licensePlate",
  ],
  gridSpeedControl: [
    "licensePlate",
    "generatedAt",
    "speed",
    "location",
  ],
  gridProtocols: [
    "protocolId",
    "plate",
    "alert",
    "vehicleId",
  ],
  gridSystemLogs: [
    "date",
    "operationType",
    "userName",
    "loggedUserName",
    "logDescription",
  ],
  gridSummaryVehicles: [
    "licensePlate",
    "licensePlateType",
    "vehicleGroupName",
    "color",
    "vehicleModel",
    "manufacturer",
    "vehicleCategory",
    "manufactureYear",
    "modelYear",
  ],
};
